"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _styles = _interopRequireDefault(require("./styles"));
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _provider = require("../../lib/provider");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VirtualProviderDogEarBanner = _ref => {
  let {
    config,
    provider,
    intl
  } = _ref;
  const visibility = (0, _providerComponents.getVisibility)(config);
  const isVirtualProvider = (0, _provider.isVirtualProvider)(provider, visibility);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isVirtualProvider && /*#__PURE__*/_react.default.createElement(_styles.default, {
    "data-testid": "VirtualProviderDogEarBanner",
    title: intl.formatMessage(_messages.default.virtualproviderdogearbanner)
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.virtualproviderdogearbanner)));
};
var _default = exports.default = (0, _intl.injectIntl)(VirtualProviderDogEarBanner);
VirtualProviderDogEarBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VirtualProviderDogEarBanner"
};